module.exports = __webpack_public_path__ + "img/paywx.67d5e49f.png";